import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

// Import translation files
import en from './locales/en.json'
import sqAL from './locales/sq-AL.json'
import bsBA from './locales/bs-BA.json'
import bgBG from './locales/bg-BG.json'
import hrHR from './locales/hr-HR.json'
import csCZ from './locales/cs-CZ.json'
import daDK from './locales/da-DK.json'
import nlNL from './locales/nl-NL.json'
import enGB from './locales/en-GB.json'
import enUS from './locales/en-US.json'
import etEE from './locales/et-EE.json'
import fiFI from './locales/fi-FI.json'
import frFR from './locales/fr-FR.json'
import deDE from './locales/de-DE.json'
import elGR from './locales/el-GR.json'
import huHU from './locales/hu-HU.json'
import isIS from './locales/is-IS.json'
import itIT from './locales/it-IT.json'
import lvLV from './locales/lv-LV.json'
import ltLT from './locales/lt-LT.json'
import mkMK from './locales/mk-MK.json'
import noNO from './locales/no-NO.json'
import plPL from './locales/pl-PL.json'
import ptPT from './locales/pt-PT.json'
import roRO from './locales/ro-RO.json'
import ruRU from './locales/ru-RU.json'
import skSK from './locales/sk-SK.json'
import slSI from './locales/sl-SI.json'
import esES from './locales/es-ES.json'
import svSE from './locales/sv-SE.json'
import ukUA from './locales/uk-UA.json'

const resources = {
  en: { translation: en },
  'sq-AL': { translation: sqAL },
  'bs-BA': { translation: bsBA },
  'bg-BG': { translation: bgBG },
  'hr-HR': { translation: hrHR },
  'cs-CZ': { translation: csCZ },
  'da-DK': { translation: daDK },
  'nl-NL': { translation: nlNL },
  'en-GB': { translation: enGB },
  'en-US': { translation: enUS },
  'et-EE': { translation: etEE },
  'fi-FI': { translation: fiFI },
  'fr-FR': { translation: frFR },
  'de-DE': { translation: deDE },
  'el-GR': { translation: elGR },
  'hu-HU': { translation: huHU },
  'is-IS': { translation: isIS },
  'it-IT': { translation: itIT },
  'lv-LV': { translation: lvLV },
  'lt-LT': { translation: ltLT },
  'mk-MK': { translation: mkMK },
  'no-NO': { translation: noNO },
  'pl-PL': { translation: plPL },
  'pt-PT': { translation: ptPT },
  'ro-RO': { translation: roRO },
  'ru-RU': { translation: ruRU },
  'sk-SK': { translation: skSK },
  'sl-SI': { translation: slSI },
  'es-ES': { translation: esES },
  'sv-SE': { translation: svSE },
  'uk-UA': { translation: ukUA },
  // Legacy mappings for backward compatibility
  cs: { translation: csCZ },
  sk: { translation: skSK },
  de: { translation: deDE },
  ru: { translation: ruRU }
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 't8r-language',
      caches: ['localStorage']
    },

    interpolation: {
      escapeValue: false // React already escapes values
    },

    react: {
      useSuspense: false
    }
  })

export default i18n